export default "<img class=\"{{ class }}\" src=\"{{ src }}\" alt=\"{{ 'general.stephubs' | translate }}\" />";